import { useLazyQuery, useQuery } from "@apollo/client";

import { GET_VIEWER_TEAMS, DISCOVER_TEAMS } from "MVVM/GraphQL/team";
import { useGetUser } from "userStore";

export const TeamsHubViewModel = () => {
  const currentUser = useGetUser();

  const [
    getViewerTeams,
    { loading: isLoadingTeams, error: hasTeamsError, data, refetch },
  ] = useLazyQuery(GET_VIEWER_TEAMS, {
    fetchPolicy: "network-only",
  });

  const rawTeams = data?.me?.teams?.nodes || [];

  const teams = rawTeams.map((team: any) => {
    const isOwner = team.owner?._id === currentUser?._id;
    return {
      ...team,
      members: team.members?.map((m: any) => m.user) || [],
      userRole: isOwner ? "OWNER" : "MEMBER",
    };
  });

  return {
    getViewerTeams,
    refetchTeams: refetch,
    teams,
    isLoadingTeams,
    hasTeamsError,
  };
};

export const useDiscoverTeams = (
  game?: string,
  sort?: string,
  limit: number = 15,
) => {
  const { data, loading, error } = useQuery(DISCOVER_TEAMS, {
    variables: {
      limit,
      game: game || undefined,
      sort: sort || "POPULAR",
    },
  });

  return {
    discoverTeams: data?.discoverTeams || [],
    isLoadingDiscover: loading,
    hasDiscoverError: error,
  };
};
